/* eslint-disable no-param-reassign */
import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import {
    type SetMemberTeamsPayload,
    TEAM_MEMBER_SLICE_NAME,
    type TeamMemberState,
} from "./teamMember.types";

import type {MemberTeamsQuery} from "../types/teamMember.dto";

const initialState: TeamMemberState = {
    teams: {
        data: null,
        cachedAt: null,
    },
};

export const teamMemberSlice = createSlice({
    name: TEAM_MEMBER_SLICE_NAME,
    initialState,
    reducers: {
        setMemberTeams(state, action: PayloadAction<SetMemberTeamsPayload>) {
            state.teams = {data: action.payload.data, cachedAt: action.payload.cachedAt};
        },
        /** Call this to manually invalidate (e.g. after a mutation) */
        invalidateMemberTeams(state) {
            state.teams.cachedAt = null;
        },
        resetMemberTeams(state) {
            state.teams = {data: null, cachedAt: null};
        },
    },
});

export const {setMemberTeams, invalidateMemberTeams, resetMemberTeams} =
    teamMemberSlice.actions;
export default teamMemberSlice.reducer;
